import { Spin } from 'antd';
import { SpinSize } from 'antd/lib/spin';
import React from 'react';
import styled, { css } from 'styled-components';

export enum LoadingPosition {
  middle = 'middle',
  bottom = 'relative',
  absolute = 'absolute',
  none = 'none'
}

const Container = styled.div`
  left: 50%;
  position: ${({ position }: IProps) => position || 'fixed'};

  ${({ position }: IProps) =>
    position !== LoadingPosition.bottom &&
    css`
      top: 50%;
      transform: translate(-50%, -50%);
    `}

  ${({ position }: IProps) =>
    position === LoadingPosition.none &&
    css`
      transform: unset;
      position: unset;
      && .ant-spin {
        top: 10%;
      }
    `}
`;

type IProps = {
  size?: SpinSize;
  position?: LoadingPosition;
  loading?: boolean;
};

const Loading: React.FC<React.PropsWithChildren<IProps>> = ({
  size = 'large',
  position,
  loading = true,
  children
}) => {
  return (
    <Container position={position}>
      <Spin size={size} spinning={loading}>
        {children}
      </Spin>
    </Container>
  );
};

export default Loading;
